import { render, staticRenderFns } from "./Func8Detalhe.vue?vue&type=template&id=009aa35a&scoped=true"
import script from "./Func8Detalhe.vue?vue&type=script&lang=js"
export * from "./Func8Detalhe.vue?vue&type=script&lang=js"
import style0 from "./Func8Detalhe.vue?vue&type=style&index=0&id=009aa35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009aa35a",
  null
  
)

export default component.exports